import { collator } from './i18n'
import type { VillageSummary } from './types'

export function sortedVillages(villages: VillageSummary[]): VillageSummary[] {
  return villages
    .slice()
    .sort(
      (left, right) =>
        collator().compare(left.displayName, right.displayName) ||
        left.villageId.localeCompare(right.villageId),
    )
}

export function preferredVillage(
  villages: VillageSummary[],
  preferredId: string | null,
): VillageSummary | null {
  if (villages.length === 0) return null
  return (
    villages.find((village) => village.villageId === preferredId) ??
    sortedVillages(villages)[0] ??
    null
  )
}

export function villagePreferenceKey(
  accountId: string,
  worldId: string,
): string {
  return `ci.village.${accountId}.${worldId}`
}
